import { Link } from 'react-router-dom';
import { useLanguage } from './language-context';
import { brand, social } from '../theme/tokens';
import { BrandLockup } from './brand-lockup';
import { ThemeSwitch } from './theme-switch';
import { LanguageToggle } from './language-toggle';

// The v3 site footer: lockup + tagline, three link columns, then a bottom bar with
// social, the theme and language switches, and the copyright.
//
// The direct-payment disclaimer sits here as well as on the booking pages. FR-P4
// requires it on the how-booking-works band, the trust band AND the footer — three
// placements deliberately, because a customer who scrolls past the first two should
// still meet it before leaving the page.
export function SiteFooter() {
  const { t } = useLanguage();

  const columns = [
    {
      title: t('footer.resources'),
      links: [
        { label: t('footer.blog'), to: '/blog' },
        { label: t('footer.help'), to: '/help' },
        { label: t('footer.about'), to: '/about' },
        { label: t('footer.contact'), to: '/contact' },
      ],
    },
    {
      title: t('footer.for_business'),
      links: [
        { label: t('footer.list_free'), to: '/for-business' },
        { label: t('footer.post_offer'), to: '/post-an-offer' },
        { label: t('footer.get_featured'), to: '/get-featured' },
      ],
    },
    {
      title: t('footer.legal'),
      links: [
        { label: t('footer.terms'), to: '/terms' },
        { label: t('footer.privacy'), to: '/privacy' },
      ],
    },
  ];

  return (
    <footer className="ftr">
      <div className="ftr__inner">
        <div className="ftr__top">
          <div className="ftr__brandcol">
            <BrandLockup />
            <p className="ftr__tagline">{t('footer.tagline')}</p>
          </div>

          {columns.map((col) => (
            <nav className="ftr__col" key={col.title} aria-label={col.title}>
              <div className="ftr__coltitle">{col.title}</div>
              {col.links.map((l) => (
                <Link className="ftr__link" key={l.label} to={l.to}>
                  {l.label}
                </Link>
              ))}
            </nav>
          ))}
        </div>

        <div className="ftr__bottom">
          <nav className="ftr__social" aria-label={t('footer.social')}>
            <a className="ftr__slink" href={social.facebook} target="_blank" rel="noreferrer noopener">
              {t('footer.facebook')}
            </a>
            <a className="ftr__slink" href={social.instagram} target="_blank" rel="noreferrer noopener">
              {t('footer.instagram')}
            </a>
            <a className="ftr__slink" href={social.youtube} target="_blank" rel="noreferrer noopener">
              {t('footer.youtube')}
            </a>
          </nav>
          <div className="ftr__controls">
            <ThemeSwitch />
            <LanguageToggle />
          </div>
        </div>
      </div>

      {/* Brand outro (v3): copyright + brand line over a faint grid, a large wordmark
          watermark, and a thin ink strip at the very bottom. */}
      <div className="ftr__outro">
        <div className="ftr__grid" aria-hidden="true" />
        <div className="ftr__outroinner">
          <div className="ftr__legal">
            <div className="ftr__copy">{t('footer.copyright')}</div>
            <div className="ftr__brandline">
              <span className="ftr__dots" aria-hidden="true">
                <span className="ftr__dot ftr__dot--a" />
                <span className="ftr__dot ftr__dot--b" />
                <span className="ftr__dot ftr__dot--c" />
              </span>
              <span className="ftr__brandtag">{t('v3home.tagline')}.</span>
            </div>
          </div>
          <div className="ftr__watermark" aria-hidden="true">
            {brand.name}
          </div>
        </div>
        <div className="ftr__strip" aria-hidden="true" />
      </div>
    </footer>
  );
}
